import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { FavoriteProvider } from './pages/FavoritePage/FavoriteContext';
import { CompareProvider } from './pages/ComparePage/CompareContext';
import { router } from './router/router';
import './style.css';
import './index.css';
import { FlatProvider } from './pages/FlatCardPage/FlatContext';
import { BusinessProvider } from './pages/BusinessCardPage/BusinessContext';
import { ParkingProvider } from './pages/ParkingCardPage/ParkingContext';
import { LoaderProvider } from './components/Loader/LoaderContext';
import { YandexMetrica } from './yandexmetrica';

const root = ReactDOM.createRoot(document.getElementById('root')!);

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <YandexMetrica />
      <LoaderProvider>
        <CompareProvider>
          <FavoriteProvider>
            <ParkingProvider>
            <BusinessProvider>
            <FlatProvider>
              <RouterProvider router={router} />
            </FlatProvider>
            </BusinessProvider>
            </ParkingProvider>
          </FavoriteProvider>
        </CompareProvider>
      </LoaderProvider>
    </React.StrictMode>
  );
};

router.subscribe(() => {
  window.scrollTo(0, 0);
  renderApp();
});

renderApp();